import { useI18nTranslation } from '../../lib/use-i18n-translation';
import type { DivisionCard } from './content/divisions';

const List = ({ title, items }: { title: string; items: readonly string[] }) => (
  <div>
    <p className="text-[11px] font-semibold uppercase tracking-wide text-muted-foreground">{title}</p>
    <ul className="mt-1 list-disc space-y-0.5 ps-4 text-xs leading-relaxed text-foreground">
      {items.map((item) => (
        <li key={item}>{item}</li>
      ))}
    </ul>
  </div>
);

/** One division's mandate as the board wrote it (static copy). */
export const DivisionCardView = ({ card }: { card: DivisionCard }) => {
  const { t } = useI18nTranslation();

  return (
    <article
      className="space-y-3 rounded-lg border border-border bg-card p-5"
      data-division={card.code}
    >
      <header>
        <p className="text-[11px] uppercase tracking-wide text-muted-foreground">{card.stage}</p>
        <h3 className="text-base font-semibold text-foreground">
          <span className="me-2 font-mono text-sm text-muted-foreground">{card.code}</span>
          {card.name}
        </h3>
      </header>
      <p className="text-sm leading-relaxed text-foreground">{card.mission}</p>
      <dl className="grid gap-1 text-xs sm:grid-cols-[6rem_minmax(0,1fr)]">
        <dt className="text-muted-foreground">{t('board.sheets.lead')}</dt>
        <dd className="text-foreground">{card.lead}</dd>
        <dt className="text-muted-foreground" />
        <dd className="text-muted-foreground">{card.model}</dd>
      </dl>
      <ul className="flex flex-wrap gap-1.5">
        {card.kpis.map((kpi) => (
          <li
            key={kpi}
            className="rounded border border-border px-1.5 py-0.5 text-[11px] text-muted-foreground"
          >
            {kpi}
          </li>
        ))}
      </ul>
      <div className="grid gap-3 md:grid-cols-2">
        <List
          title={t('board.sheets.responsibilities')}
          items={card.responsibilities}
        />
        <div className="space-y-3">
          <List
            title={t('board.sheets.reporting')}
            items={card.reporting}
          />
          <List
            title={t('board.sheets.agenda')}
            items={card.agenda}
          />
        </div>
      </div>
      <div>
        <p className="text-[11px] font-semibold uppercase tracking-wide text-muted-foreground">{t('board.sheets.deliverables')}</p>
        <ul className="mt-1 space-y-1 text-xs">
          {card.deliverables.map((deliverable) => (
            <li
              key={deliverable.tag}
              className="grid grid-cols-[6.5rem_minmax(0,1fr)] gap-2"
            >
              <span className="font-medium text-foreground">{deliverable.tag}</span>
              <span className="text-muted-foreground">{deliverable.what}</span>
            </li>
          ))}
        </ul>
      </div>
    </article>
  );
};
